import { create } from 'zustand'

/** Whether the assistant panel is open (and has ever been); the toaster reads it to stay clear. */
export const useAssistantPanel = create<{ open: boolean; opened: boolean; setOpen: (open: boolean) => void }>((set) => ({
  open: false,
  opened: false,
  setOpen: (open) => set((state) => ({ open, opened: state.opened || open })),
}))

const SMARTQUOTE_SECTIONS = ['/quotes', '/communications']

/** The Quotes sidebar section (My Quotes, New Quote, Email): the only pages that show SmartQuote (USA-1450). */
export function isSmartQuotePath(pathname: string) {
  return SMARTQUOTE_SECTIONS.some((section) => pathname === section || pathname.startsWith(`${section}/`))
}
